<template lang="pug" >
	v-card.style-html(style="margin:10px;overflow-y:hidden" dark)
		v-card-title(style="padding:0px;")
			v-layout(row,wrap)
				v-flex(xs12 sm8 md8 xl8 lg8  text-md-left text-xs-center text-sm-left text-xl-left text-lg-left)
					p.title(class="white--text") {{titulo}}
					p.subtitle 
				v-flex(xs12 sm4 md4 xl4 lg4 text-md-right text-xs-center text-sm-right text-xl-right text-lg-right)
					v-btn(v-if="showCancelar" color="default", dark @click="onCancelar")
						| VOLVER ATRAS
		v-divider
		v-card-text(style="position: relative;padding-bottom: 56.25%;height: 100%;overflow-y: hidden;")
			iframe(:src="urlData",style="position: absolute;top:0;left: 0;width: 100%;height: 80%;",allowfullscreen)
</template>
<style>
	.text-normal{
		text-transform: initial;
	}

</style>
<script>
module.exports = {
  props: {
    onCancelar: {
      type: Function,
      required: false
    },
    url: {
      type: String,
      required: true
    },
    titulo: {
      type: String,
      required: false
    },
    showCancelar: {
      type: Boolean,
      required: false,
      "default": true
    }
  },
  data: function() {
    return {
      urlData: '',
      loadingReporte: true
    };
  },
  created: function() {
    return console.log("created");
  },
  mounted: function() {
    return this.$nextTick(function() {
      return this.urlData = this.url;
    });
  }
};

// ---
</script>


